import i18n from '~/i18n'
import { primary as theme } from '~/styles/themes'

import { formatCompareMetricLabel, formatStylesChart } from '../../helpers'
import { CreateDataset } from '../types'
import { OptionsScale } from './types'

const axisID = 'y-newToBrandCustomers'

const settings = {
  label: i18n.t('rm:metrics.newToBrandCustomers'),
  color: theme.colors.warningPure,
  dataKey: 'newToBrandCustomersNumber' as keyof ReportHistoryCampaigns,
  order: 120
}

const dataset: CreateDataset = ({ data, isCompare = false }) => ({
  yAxisID: isCompare ? `${axisID}-compare` : axisID,
  type: 'line',
  label: formatCompareMetricLabel({ label: settings.label, isCompare }),
  data: data?.[settings.dataKey] || null,
  order: isCompare ? settings.order - 1 : settings.order,

  ...formatStylesChart({ color: settings.color, isCompare })
})

const optionsScale: OptionsScale = ({
  showScaleRuler = true,
  drawOnChartArea = true,
  position = 'left',
  isCompare = false
}) => ({
  [isCompare ? `${axisID}-compare` : axisID]: {
    display: showScaleRuler,
    grid: {
      drawOnChartArea
    },
    position,
    suggestedMin: 0,
    beginAtZero: true,
    ticks: {
      z: -1,
      color: settings.color
    }
  }
})

const newToBrandCustomersPreset = { axisID, dataset, optionsScale, settings }

export default newToBrandCustomersPreset
